import axios from '@/utils/axios';

export const documentTemplates = async (type) => {
 const response = await axios.get(`/document-templates/${type}/by-type`);
 return response;
};
